import { MAABAR_AI_ENDPOINT, maabarAiHeaders } from './config';

// The trader calculator on web calls maabar-ai's `cost_calculator` task
// directly with STRUCTURED input (Stage 2, 2026-10-12). The server validates
// every field, asks Gemini for estimates only and computes every figure itself
// (supabase/functions/maabar-ai/calculator.ts), so no prompt travels from here.
//
// Ai-proxy is NOT used by web any more. It stays deployed only for installed
// mobile builds (1.0.x – 1.1.2), which send the three legacy prompts.
//
// Headers carry the signed-in user's token when there is one, so the server's
// rate limit keys on the user instead of on a shared IP.

export const CALC_KINDS = ['import_cost', 'shipping', 'profit'];

export function buildCalcPayload(kind, input) {
  if (!CALC_KINDS.includes(kind)) throw new Error(`Unknown calculator kind: ${kind}`);
  return { task: 'cost_calculator', payload: { kind, input } };
}

export async function requestCalculator(kind, input, { fetchImpl = fetch, headers } = {}) {
  const response = await fetchImpl(MAABAR_AI_ENDPOINT, {
    method: 'POST',
    headers: headers || await maabarAiHeaders(),
    body: JSON.stringify(buildCalcPayload(kind, input)),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.error || !data?.result) {
    const err = new Error(data?.error || `Calculator request failed with status ${response.status}`);
    err.status = response.status;
    throw err;
  }
  return data.result;
}
